export default __webpack_public_path__ + "static/media/web-exploitation.2d4d3547.jpg";